export default function WhyChoose() {
  const reasons = [
    {
      icon: 'ri-flashlight-line',
      title: 'Tecnologia de ponta',
      description: 'Utilizamos equipamentos modernos de depilação a laser, desenvolvidos para entregar alta performance com máximo conforto, adaptando a intensidade para cada tipo de pele.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Resultados visíveis desde as primeiras sessões',
      description: 'A tecnologia age diretamente no folículo piloso, reduzindo o crescimento do pelo de forma progressiva e duradoura.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Seguro e Eficaz',
      description: 'Tratamento seguro e eficaz, respeitando as características individuais de cada cliente.'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 xl:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-black text-center mb-10 sm:mb-12 lg:mb-16">
          Por Que Escolher a GIO Estética Avançada de Americana?
        </h2>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-white border border-gray-200 rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#E91E63] rounded-full mb-6">
                <i className={`${reason.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-black mb-3 sm:mb-4">
                {reason.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        {/* Technology Section */}
        <div className="bg-gradient-to-br from-[#E91E63]/5 to-[#E91E63]/10 rounded-2xl sm:rounded-3xl p-8 sm:p-10 md:p-12 max-w-5xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-12 h-12 flex items-center justify-center bg-[#E91E63] rounded-full">
              <i className="ri-flashlight-fill text-white text-2xl"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-black">
              Nossa Tecnologia
            </h3>
          </div>
          
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p className="text-base sm:text-lg">
              Na <span className="font-bold text-black">GIO Estética Avançada – Americana</span> você realiza sua depilação com o <span className="font-bold text-[#E91E63]">laser Alexandrite 755nm</span> da italiana <span className="font-semibold">Quanta Systems</span> — considerado padrão ouro mundial para remoção definitiva dos pelos.
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              <div className="flex items-center gap-2">
                <span className="text-[#E91E63] text-xl">✨</span>
                <span className="font-medium text-black">Mais potência</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-[#E91E63] text-xl">✨</span>
                <span className="font-medium text-black">Mais eficiência</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-[#E91E63] text-xl">✨</span>
                <span className="font-medium text-black">Mais conforto</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-[#E91E63] text-xl">✨</span>
                <span className="font-medium text-black">Resultados visíveis desde as primeiras sessões</span>
              </div>
            </div>

            <p className="text-base sm:text-lg">
              Diferente de tecnologias comuns, o Alexandrite possui alta afinidade com a melanina do pelo, proporcionando:
            </p>

            <div className="grid sm:grid-cols-2 gap-4">
              <div className="flex items-start gap-3">
                <span className="text-[#16A34A] text-xl flex-shrink-0">✔️</span>
                <span>Redução acelerada dos pelos</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-[#16A34A] text-xl flex-shrink-0">✔️</span>
                <span>Pele mais lisa e uniforme</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-[#16A34A] text-xl flex-shrink-0">✔️</span>
                <span>Sessões rápidas</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-[#16A34A] text-xl flex-shrink-0">✔️</span>
                <span>Segurança com avaliação personalizada</span>
              </div>
            </div>

            <p className="text-base sm:text-lg font-medium text-black">
              Nosso sistema conta com resfriamento avançado, tornando o procedimento muito mais confortável.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
